import React from 'react';
import { Button } from 'antd';
import { isHasAccess } from 'features/validateAccess';
import { useDeleteCalendarEventMutation } from 'entities/calendar';
import { ReactComponent as DeleteIcon } from 'shared/assets/icons/calendarDelete.svg';
import { UPDATE_CALENDAR } from '../../../permissions';

import styles from './UpdateCalendarEventFooter.module.scss';

const UpdateCalendarEventFooter = ({
  calendarId,
  eventId,
  closeModal,
  children,
}: {
  eventId: string;
  calendarId: string;
  closeModal: () => void;
  children: React.ReactNode;
}): React.ReactElement => {
  const { mutateAsync: deleteEventMutation, isPending } = useDeleteCalendarEventMutation(calendarId, eventId);
  const canDeleteEvent = isHasAccess(UPDATE_CALENDAR);

  const handleDelete = async (): Promise<void> => {
    await deleteEventMutation();
    closeModal();
  };
  return (
    <div className={styles.wrapper}>
      {canDeleteEvent ? <Button icon={<DeleteIcon />} danger onClick={handleDelete} loading={isPending} /> : <div />}
      <div className={styles.actionsBtnBlock}>{children}</div>
    </div>
  );
};

export { UpdateCalendarEventFooter };
